import React, { createContext, Dispatch, SetStateAction, useContext, useState } from "react";

type ProfileDisplayContext = {
    displayProfile: boolean;
    setDisplayProfile: Dispatch<SetStateAction<boolean>>;
    personnelId: string;
    setPersonnelId: Dispatch<SetStateAction<string>>;
    readOnly: boolean;
    setReadOnly: Dispatch<SetStateAction<boolean>>;
    resetProfileView: () => void;
};

const ProfileDisplayContext = createContext<ProfileDisplayContext>({
    displayProfile: null,
    setDisplayProfile: null,
    personnelId: null,
    setPersonnelId: null,
    readOnly: false,
    setReadOnly: null,
    resetProfileView: null,
});

const ProfileDisplayContextProvider: React.FC = ({ children }) => {
    const [displayProfile, setDisplayProfile] = useState(false);
    const [personnelId, setPersonnelId] = useState(null);
    const [readOnly, setReadOnly] = useState(false);

    const resetProfileView = () => {
        setReadOnly(false);
    };

    return (
        <ProfileDisplayContext.Provider
            value={{
                displayProfile,
                setDisplayProfile,
                personnelId,
                setPersonnelId,
                readOnly,
                setReadOnly,
                resetProfileView,
            }}
        >
            {children}
        </ProfileDisplayContext.Provider>
    );
};

const useProfileDisplay = (): ProfileDisplayContext => {
    const profileDisplayContext = useContext<ProfileDisplayContext>(ProfileDisplayContext);
    if (!profileDisplayContext) {
        throw new Error(`useProfileDisplay must be used within a ProfileDisplayContextProvider`);
    }
    return profileDisplayContext;
};

export { ProfileDisplayContextProvider, useProfileDisplay };
